module.exports = __webpack_public_path__ + "static/media/riesgo.4e453e7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/driving/riesgo.png
// module id = 738
// module chunks = 0